"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _state = _interopRequireDefault(require("./state"));
/* eslint-disable */
var RoapCollection = {
  sessions: {},
  getSession: function getSession(id) {
    if (!this.sessions[id]) {
      this.sessions[id] = {
        activeSequences: 0
      };
    }
    return this.sessions[id];
  },
  deleteSession: function deleteSession(id) {
    if (this.getSession(id)) {
      delete this.sessions[id];
    }
  },
  getSessionSequence: function getSessionSequence(id, seqId) {
    var session = this.getSession(id);
    if (!session[seqId]) {
      session[seqId] = {
        state: _state.default.createState(),
        finished: false
      };
      session.activeSequences += 1;
    }
    return session[seqId];
  },
  deleteSessionSequence: function deleteSessionSequence(id, seqId) {
    var seq = this.getSessionSequence(id, seqId);
    if (seq) {
      if (!seq.finished) {
        // @ts-ignore
        session.activeSequences -= 1;
      }
      delete this.sessions[id][seqId];
    }
  },
  isBusy: function isBusy(id) {
    var session = this.getSession(id);
    if (!session) return false;
    return session.activeSequences > 0;
  },
  onSessionSequenceFinish: function onSessionSequenceFinish(id, seqId) {
    var session = this.getSession(id);
    var seq = session[seqId];
    if (seq && !seq.finished) {
      seq.finished = true;
      session.activeSequences -= 1;
    }
  }
};
var _default = RoapCollection;
exports.default = _default;
//# sourceMappingURL=collection.js.map
